import debounce from 'lodash.debounce';

const ATTR_NAME = 'data-uid';
const mapping = {};
const clickedOutside = debounce(function (event) {
    for (const key in mapping) {
        const value = mapping[key];
        const el = value.el;
        const fn = value.fn;
        if (!(el === event.target || el.contains(event.target))) {
            fn(event);
        }
    }
}, 150);

const clickOutside = {
    bind : function (el, binding, vnode) {
        const uid = vnode.context._uid;
        el.setAttribute(ATTR_NAME, uid);
        const fn = vnode.context[binding.expression];
        mapping[uid] = { el : el, fn : fn };
    },
    unbind : function (el) {
        const uid = el.getAttribute(ATTR_NAME);
        delete mapping[uid];
    }
};

const GlobalDirectives = {
    install (Vue) {
        document.body.addEventListener('click', clickedOutside);
        Vue.directive('click-outside', clickOutside);
    }
};

export default GlobalDirectives;
